//frontend/src/pages/Register.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, TextField, Button, Box, Paper, FormControl, FormControlLabel, Radio, RadioGroup, Alert } from '@mui/material';
import axiosInstance from '../utils/axios';
import Turnstile from "react-turnstile";
import { useTranslation } from 'react-i18next';


export default function Register() {
    const { t } = useTranslation();
    
   const [formData, setFormData] = useState({
       name: '',
       email: '',
       password: '',
       role: 'client',
       phone: '',
       telegram: '',
       instagram: '',
       // captchaToken: ''
   });
   const [error, setError] = useState('');
   const navigate = useNavigate();

   const handleSubmit = async (e) => {
       e.preventDefault();

             {/* CLOUDFLARE CAPTCHA КОМЕНТ
        
       if (!formData.captchaToken) {
           setError('Please complete the captcha');
           return;
       }

       */}

       try {
           const response = await axiosInstance.post('/auth/register', formData);
           
           if (formData.role === 'specialist') {
               alert('Registration successful. Waiting for admin approval.');
               navigate('/login');
               return;
           }

           localStorage.setItem('token', response.data.token);
           navigate('/dashboard');
       } catch (error) {
           setError(error.response?.data?.message || 'Registration failed');
       }
   };

   return (
       <Container maxWidth="sm">
           <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
               <Typography variant="h4" align="center" gutterBottom>
               {t('common.register')}
               </Typography>

               {error && (
                   <Alert severity="error" sx={{ mb: 2 }}>
                       {error}
                   </Alert>
               )}

               <Box component="form" onSubmit={handleSubmit}>
                   <TextField
                       required
                       fullWidth
                       label={t('common.name')}
                       value={formData.name}
                       onChange={(e) => setFormData({...formData, name: e.target.value})}
                       margin="normal"
                   />
                   <TextField
                       required
                       fullWidth
                       label={t('common.email')}
                       type="email"
                       value={formData.email}
                       onChange={(e) => setFormData({...formData, email: e.target.value})}
                       margin="normal"
                   />
                   <TextField
                       required
                       fullWidth
                       label={t('common.phone')}
                       value={formData.phone}
                       onChange={(e) => setFormData({...formData, phone: e.target.value})}
                       margin="normal"
                   />
                   <TextField
                       required
                       fullWidth
                       label={t('common.password')}
                       type="password"
                       value={formData.password}
                       onChange={(e) => setFormData({...formData, password: e.target.value})}
                       margin="normal"
                   />

                   <FormControl component="fieldset" sx={{ mt: 2, width: '100%' }}>
                       <RadioGroup
                           row
                           value={formData.role}
                           onChange={(e) => setFormData({...formData, role: e.target.value})}
                       >
                           <FormControlLabel value="client" control={<Radio />} label={t('common.client')} />
                           <FormControlLabel value="specialist" control={<Radio />} label={t('common.specialist')} />
                       </RadioGroup>
                   </FormControl>

                   <TextField
                       fullWidth
                       label={t('common.telegramoptional')}
                       value={formData.telegram}
                       onChange={(e) => setFormData({...formData, telegram: e.target.value})}
                       margin="normal"
                   />
                   <TextField
                       fullWidth
                       label={t('common.instagramoptional')}
                       value={formData.instagram}
                       onChange={(e) => setFormData({...formData, instagram: e.target.value})}
                       margin="normal"
                   />
                   
                   <Box sx={{ my: 2 }}>
                          {/* CLOUDFLARE CAPTCHA КОМЕНТ

        
                   <Turnstile
    sitekey="0x4AAAAAAAhUcixge2JYRXG_"
    onVerify={(token) => setFormData({...formData, captchaToken: token})}
    onError={() => {
        console.error('Turnstile error');
        setError('Error validating captcha');
    }}
    onExpire={() => {
        console.log('Turnstile expired');
        setFormData({...formData, captchaToken: ''});
    }}
/>

*/}

                   </Box>

                   <Button
                       type="submit"
                       fullWidth
                       variant="contained"
                       sx={{ mt: 3 }}
                   >
                       {t('common.register')}
                   </Button>

                   <Button
                       fullWidth
                       variant="text"
                       onClick={() => navigate('/login')}
                       sx={{ mt: 1 }}
                   >
                       {t('common.alreadyhaveanaccount')}
                   </Button>
               </Box>
           </Paper>
       </Container>
   );
}